module.exports = __webpack_public_path__ + "static/media/lupa-purple.7bdf4c9e.svg";